<template>
    <b-container fluid style="height: 100%; padding: 0">
        <b-container v-if="mainState === 100">
            <b-row style="font-size: 35px; padding-top: 100px">
                <b-col>
                    <img :src="this.$icons.iconTrash" alt="" class="mx-auto" style="width: 70px" />
                </b-col>
            </b-row>
            <b-row style="font-size: 24px; padding-top: 24px">
                <b-col> Ihr Kassenzettel wurde erfolgreich gelöscht. </b-col>
            </b-row>
        </b-container>

        <b-container v-else-if="mainState === -2">
            <b-row style="font-size: 35px; padding-top: 100px; color: red">
                <b-col> CONNECTION ERROR </b-col>
            </b-row>
            <b-row style="font-size: 24px; padding-top: 24px">
                <b-col> Es konnte keine Verbindung zum Server hergestellt werden. </b-col>
            </b-row>
            <b-row style="padding-top: 24px">
                <b-col>
                    <b-button class="button-filled">Erneut versuchen</b-button>
                </b-col>
            </b-row>
        </b-container>

        <b-container v-else-if="mainState === -1">
            <b-row style="font-size: 45px; padding-top: 100px">
                <b-col> 404 </b-col>
            </b-row>
            <b-row style="font-size: 24px; padding-top: 24px">
                <b-col>
                    Dieser Link scheint nicht zu funktionieren.
                    <br />
                    Wurde ein entsprechender Hashcode angegeben?
                </b-col>
            </b-row>
        </b-container>

        <b-container v-else-if="mainState === 0" style="padding-top: 100px">
            <b-row style="font-size: 24px">
                <b-col> Einen Augenblick Geduld bitte.. </b-col>
            </b-row>

            <b-row style="font-size: 18px; margin-top: 50px">
                <b-col>
                    <b-spinner style="width: 3rem; height: 3rem"></b-spinner>
                </b-col>
            </b-row>

            <b-row style="font-size: 18px; margin-top: 50px">
                <b-col> Ihr Kassenzettel wird in diesem Moment erzeugt. </b-col>
            </b-row>
        </b-container>

        <b-container v-else-if="mainState === 1" style="margin-top: 100px">
            <b-row style="font-size: 45px">
                <b-col>404</b-col>
            </b-row>
            <b-row style="font-size: 24px">
                <b-col>Kein Kassenzettel gefunden..</b-col>
            </b-row>
            <b-row style="font-size: 24px; margin-top: 50px">
                <b-col>
                    <img
                        :src="this.$icons.iconDocument"
                        class="mx-auto"
                        style="width: 100px"
                        alt=""
                    />
                </b-col>
            </b-row>
            <b-row style="font-size: 18px; margin-top: 50px">
                <b-col>
                    Für die von Ihnen angefragte Addresse konnte leider kein Kassenzettel gefunden
                    werden.
                </b-col>
            </b-row>
        </b-container>

        <div v-else-if="mainState === 2" id="mobile-container">
            <b-container id="mobile-bon-container" :style="mobileBonContainerStyle">
                <img :src="pathToPng" id="mobile-bon" :style="blurBon" alt="" />
            </b-container>

            <b-container v-if="mobile.state === 0" id="mobile-button-container-0">
                <b-row style="font-size: 32px">
                    <b-col> Kassenzettel löschen </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col> Wollen Sie Ihren Kassenzettel wirklich nicht behalten? </b-col>
                </b-row>
                <b-row style="margin-top: 30px">
                    <b-col>
                        <button class="button-filled-mobile" @click="triggerDeleteBon">
                            LÖSCHEN
                        </button>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col>
                        <button class="button-mobile" @click="increaseState">Abbrechen</button>
                    </b-col>
                </b-row>
            </b-container>

            <b-container v-else-if="mobile.state === 1" id="mobile-button-container-1">
                <b-row>
                    <b-col style="margin-top: 10px">
                        <button class="button-filled-mobile" @click="increaseState">
                            Speichern
                        </button>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col>
                        <button class="button-mobile" @click="decreaseState">Löschen</button>
                    </b-col>
                </b-row>
            </b-container>

            <b-container v-else-if="mobile.state === 2" id="mobile-button-container-2">
                <b-row>
                    <b-col style="margin-top: 10px">
                        <button
                            class="button-light-mobile flex flex-row px-3 h-10"
                            @click="triggerDownloadImage"
                        >
                            <div class="flex-1"></div>
                            <div class="flex flex-col h-full mr-5">
                                <div class="flex-1"></div>
                                <div class="flex flex-row">
                                    <div>
                                        <img
                                            :src="this.$icons.iconImage"
                                            alt=""
                                            class="h-5 mt-1 mx-3"
                                        />
                                    </div>
                                    <div>Als Bild speichern</div>
                                </div>
                                <div class="flex-1"></div>
                            </div>
                            <div class="flex-1"></div>
                        </button>
                    </b-col>
                </b-row>

                <b-row style="margin-top: 10px">
                    <b-col>
                        <button
                            class="button-light-mobile flex flex-row px-3 h-10"
                            @click="triggerDownloadPdf"
                        >
                            <div class="flex-1"></div>
                            <div class="flex flex-col h-full mr-5">
                                <div class="flex-1"></div>
                                <div class="flex flex-row">
                                    <div>
                                        <img
                                            :src="this.$icons.iconPdf"
                                            alt=""
                                            class="h-5 mt-1 mx-3"
                                        />
                                    </div>
                                    <div>Als PDF speichern</div>
                                </div>
                                <div class="flex-1"></div>
                            </div>
                            <div class="flex-1"></div>
                        </button>
                    </b-col>
                </b-row>

                <!--
                <b-row style="margin-top: 10px;">
                    <b-col>
                        <button class="button-light-mobile">
                            <img src="../assets/icon_share.svg" alt="" style="margin-right: 10px; height: 20px;">Bon teilen
                        </button>
                    </b-col>
                </b-row>
                -->

                <div style="margin-top: 10px; text-align: center">
                    <div
                        style="
                            height: 0;
                            border-bottom: 1px solid #b3b3b3;
                            width: 200px;
                            margin-left: calc(50% - 100px);
                        "
                    ></div>
                </div>

                <!--
                <b-row style="margin-top: 20px;">
                    <b-col>
                        <button class="button-filled-mobile" @click="increaseState">Anmelden / Registrieren</button>
                    </b-col>
                </b-row>
                -->

                <b-row style="margin-top: 10px">
                    <b-col>
                        <button class="button-mobile" @click="decreaseState">Abbrechen</button>
                    </b-col>
                </b-row>
            </b-container>

            <b-container v-else-if="mobile.state === 3" id="mobile-button-container-3">
                <b-row style="margin-top: 10px; font-size: 20px">
                    <b-col>
                        Alle digitalen Kassenzettel auf einen Blick.
                        <br />
                        Melden Sie sich an.
                    </b-col>
                </b-row>
                <b-row style="margin-top: 50px; font-size: 32px; font-weight: 700">
                    <b-col> Anmelden </b-col>
                </b-row>
                <b-row style="margin-top: 20px">
                    <b-col>
                        <b-input type="text" placeholder="Email" class="mobile-input"></b-input>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col>
                        <b-input
                            type="password"
                            placeholder="Passwort"
                            class="mobile-input"
                        ></b-input>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 40px">
                    <b-col>
                        <button class="button-filled-mobile">Anmelden</button>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col>
                        <button class="button-mobile" @click="decreaseState">Abbrechen</button>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 20px">
                    <b-col> Passwort vergessen? </b-col>
                </b-row>
                <b-row style="margin-top: 100px">
                    <b-col> Nutzen Sie noch nicht unseren Service? </b-col>
                </b-row>
                <b-row style="margin-top: 10px">
                    <b-col> Registrieren Sie sich hier. </b-col>
                </b-row>
            </b-container>
        </div>

        <b-container v-else>
            <b-row style="font-size: 18px; margin-top: 100px">
                <b-col> Some error occurred please reload the page! </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
    export default {
        name: 'MobilePageCyboDark1',
        data() {
            return {
                mobile: {
                    // 1 = speichern/löschen, 2 = optionen, 3 = login
                    state: 1
                }
            }
        },
        methods: {
            increaseState: function () {
                if (this.mobile.state < 3) {
                    this.mobile.state++
                }
            },
            decreaseState: function () {
                if (this.mobile.state > 0) {
                    this.mobile.state--
                }
            },
            triggerDownloadImage: function () {
                this.$emit('triggerDownloadImage')
            },
            triggerDownloadPdf: function () {
                this.$emit('triggerDownloadPdf')
            },
            triggerDeleteBon: function () {
                this.$emit('triggerDeleteBon')
            }
        },
        computed: {
            mobileBonContainerStyle: function () {
                if (this.mobile.state === 1) {
                    return 'margin-bottom: 160px'
                } else if (this.mobile.state === 2) {
                    return 'margin-bottom: 220px;'
                }
                return 'margin-bottom: 10px;'
            },
            blurBon: function () {
                if (this.mobile.state === 3) {
                    return (
                        '-webkit-filter: blur(3px);' + 'position: fixed;' + 'top: 0;' + 'left: 0;'
                    )
                }
                return ''
            }
        },
        props: {
            pathToPng: String,
            mainState: Number
        }
    }
</script>

<style>
    .button-filled-mobile {
        background-color: #002e62 !important;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
        border-radius: 25px;
        border: none;
        width: 100%;
        height: 50px;
        color: #ffffff;
        font-weight: 800;
        font-size: 18px;
    }

    .button-light-mobile {
        background-color: #e5edf4 !important;
        border-radius: 25px;
        border: none;
        width: 100%;
        height: 50px;
        color: #00162e;
        font-weight: 800;
        font-size: 18px;
    }

    .button-mobile {
        background-color: white !important;
        border-radius: 25px;
        border: 1px solid #002e62;
        width: 100%;
        height: 50px;
        color: #00162e;
        font-weight: 800;
        font-size: 18px;
    }

    #mobile-container {
        position: relative;
        height: 100%;
    }

    #mobile-bon {
        width: 100%;
        border: 1px solid lightgray;
    }

    #mobile-bon-container {
        width: 100%;
        margin-top: 60px;
        margin-bottom: 140px;
        background-color: #0f4680;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .mobile-input {
        border: none;
        border-bottom: 1px solid black;
        border-radius: 0px;
        background: none;
    }

    #mobile-button-container-0 {
        background-color: white;
        padding-top: 100px;
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
    }

    #mobile-button-container-1 {
        background-color: white;
        padding-top: 10px;
        width: 100%;
        height: 160px;
        position: fixed;
        left: 0;
        bottom: 0;
        box-shadow: 0px -1px 1px #eceded;
        border-radius: 6px 6px 0px 0px;
    }

    #mobile-button-container-2 {
        background-color: white;
        padding-top: 10px;
        width: 100%;
        /*height: 360px;*/
        height: 220px;
        position: fixed;
        left: 0;
        bottom: 0;
        box-shadow: 0px -1px 1px #eceded;
        border-radius: 6px 6px 0px 0px;
    }

    #mobile-button-container-3 {
        background-color: rgba(255, 255, 255, 0.8);
        padding-top: 10px;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0px;
        overflow-y: auto;
    }
</style>